// store/index.js
import { createStore } from 'vuex'

export default createStore({
  state: {
    user: null,
    mapping: {},
    token: null
  },

  mutations: {
    SET_USER(state, payload) {
      state.user = {
        username: payload.username || '',
        fullname: payload.employeeName || '',
        positioncode: payload.positioncode || '',
        positionname: payload.positionname || ''
      }
      state.mapping = payload.mapping || {}
      state.token = payload.auth?.token || null
    },
    LOGOUT(state) {
      state.user = null
      state.mapping = {}
      state.token = null
    }
  },

  actions: {
    saveUser({ commit }, data) {
      commit('SET_USER', data)
      try {
        localStorage.setItem(
          'user',
          JSON.stringify({
            username: data.username || '',
            fullname: data.employeeName || '',
            positioncode: data.positioncode || '',
            positionname: data.positionname || '',
            mapping: data.mapping || {},
            token: data.auth?.token || null
          })
        )
      } catch (err) {
        console.error('Gagal menyimpan user ke localStorage:', err)
      }
    },

    logout({ commit }) {
      commit('LOGOUT')
      localStorage.removeItem('user')
    },

    loadUser({ commit }) {
      const data = localStorage.getItem('user')
      if (data) {
        try {
          const parsed = JSON.parse(data)
          commit('SET_USER', {
            username: parsed.username || '',
            employeeName: parsed.fullname || '',
            positioncode: parsed.positioncode || '',
            positionname: parsed.positionname || '',
            mapping: parsed.mapping || {},
            auth: { token: parsed.token } // biar kompatibel sama SET_USER
          })
        } catch (err) {
          console.error('Gagal load user dari localStorage:', err)
          commit('LOGOUT')
        }
      }
    }
  },

  getters: {
    isLoggedIn: state => !!state.user && !!state.token,
    getUser: state => state.user,
    getMapping: state => state.mapping,
    getBranches: state => state.mapping.branch || [],
    getAreas: state => state.mapping.area || [],
    getGroupCities: state => state.mapping.groupCity || [],
    getCities: state => state.mapping.city || [],
    getDistributors: state => state.mapping.distributor || [],
    getToken: state => state.token
  }
})
